import axios from 'axios';
import {
	setAccessToken,
	setUserEmail,
	setUserId,
	setUserRole,
} from '../Utils/AuthUtil';

// eslint-disable-next-line no-undef
const baseUmsUrl = process.env.REACT_APP_UMS_API_URL;
// eslint-disable-next-line no-undef
const password_host = process.env.REACT_APP_RESET_PASSWORD_HOST;

export async function loginUser(email, password) {
	const body = `client_id=senzcare-client&client_secret=senzcare-secret&grant_type=password&username=${email}&password=${password}`;
	try {
		const response = await axios.post(`${baseUmsUrl}/oauth/token`, body);
		if (response.status === 200) {
			setAccessToken(response.data.access_token);
			setUserRole(response.data.role);
			setUserId(response.data.id);
			setUserEmail(response.data.name);
			return {
				status: response.status,
				role: response.data.role,
				userId: response.data.id,
				token: response.data.access_token,
			};
		} else {
			throw { response: { status: 400 } };
		}
	} catch (error) {
		if (error.response) {
			return error.response;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function createNewUserAccount(body) {
	try {
		const response = await axios.post(`${baseUmsUrl}/adminSignUp`, body);
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function fetchAllUsers(token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/admin`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function fetchUser(id, token, route) {
	try {
		const response = await axios.get(`${baseUmsUrl}/${route}/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function updateUser(id, token, body) {
	try {
		const response = await axios.put(`${baseUmsUrl}/admin/${id}`, body, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function deleteUser(id, token) {
	try {
		const response = await axios.delete(`${baseUmsUrl}/admin/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function resetUserPassword(body) {
	try {
		const response = await axios.post(
			`${baseUmsUrl}/reset/resetPassword`,
			body,
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function generateResetUserPasswordLink(email) {
	const body = {
		email: email,
		host: password_host,
	};

	try {
		const response = await axios.post(
			`${baseUmsUrl}/reset/request-resetPassword`,
			body,
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function createOtherUserAccount(body, route) {
	try {
		const response = await axios.post(`${baseUmsUrl}/${route}`, body);
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function fetchOtherUsers(id, token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/admin/home/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function deleteOtherUser(id, role, token) {
	try {
		const response = await axios.delete(`${baseUmsUrl}/${role}/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function fetchCareHome(id, token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/home/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function fetchCareHomeConfigs(id, token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/config/home/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function fetchCareHomeNotifications(id, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/note/home/notification/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}
